<template>
  <div class="wrap" id="i-detail-wrap">
    <div style="width:100%" v-if="mounted">
      <div :class="[child == true ? 'header-individual-child' : header_notification ? 'header-individual full header-notification-space' : 'header-individual full']">
        <div class="search-form">
          <div class="header-tabs" @click="tabs != 'summary' ? changeTab('summary') : ''" :class="tabs == 'summary' ? 'active' : ''">サマリー</div>
          <div class="header-tabs" @click="tabs != 'analysis' ? changeTab('analysis') : ''" :class="tabs == 'analysis' ? 'active' : ''">分析</div>
          <div class="header-tabs" @click="tabs != 'post' ? changeTab('post') : ''" :class="tabs == 'post' ? 'active' : ''">投稿</div>
          <div class="header-tabs" @click="tabs != 'note' ? changeTab('note') : ''" :class="tabs == 'note' ? 'active' : ''">ノート</div>


          <div class="header-tabs" @click="tabs != 'report' ? changeTab('report') : ''" :class="tabs == 'report' ? 'active' : ''">レポート</div>

          <otherSNS v-if="search_influencer_x_enabled && search_influencer_tiktok_enabled && search_influencer_youtube_enabled" :own_id="profile_data.ig_id" :other_sns="profile_data.other_sns" :similar_data="similar_data" :parent_component="parent_component" :child="child" />
          
          <div class="flex-space"></div>
        </div>
        <div class="i-detail-similar-button-wrap pointer" v-if="similar_data && !similar_loading" @click="scrollBottom()">
          <div class="i-detail-similar-icon" v-for="similar in similar_account" :key="similar.account_name">
            <el-image :src="similar.profile_picture_url" class="i-detail-header-sns-img" style="border:1px solid #fff">
              <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
            </el-image>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
        <div v-if="similar_loading" class="i-detail-similar-button-wrap pointer">
          <div v-for="n in 5" :key="n">
            <div class="i-detail-similar-icon"><div class="i-detail-header-sns-img data-table-profile-noimg w-border"></div></div>
          </div>
          <div class="i-detail-header-similar-description">類似<br />アカウント</div>
        </div>
        <div></div>
      </div>

      <div class="i-detail-wrap" v-show="!loading" :class="child == true ? 'child' : ''" id="i-detail">
        <div v-if="profile_data.deleted == 1" class="i-detail-deleted flex-row">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" style="margin-right: 5px;" />このアカウントは現在削除されています
          <div class="flex-space"></div>
          <div class="pointer i-detail-deleted-right" @click="reportError()">この表示が誤っている旨を報告する</div>
          <el-tooltip>
            <span slot="content">
              データ取得のタイミングなどにより、削除されていないアカウントでも「削除されています」と表示される場合があります。<br />この表示が誤っている場合、大変お手数ですが、ご報告をお願いいたします。
            </span>
            <font-awesome-icon :icon="['fas', 'question-circle']" class="pointer" />
          </el-tooltip>
          <el-button v-if="admin_mode && activate == 20" size="mini" type="danger" @click="deleteFlag(profile_data.ig_id)">削除フラグを修正</el-button>
        </div>
        <div class="i-detail-user-page">
          <!-- プロフィール部分 -->
          <div class="profile" :style="tabs == 'post' || tabs == 'note' || tabs == 'report' ? 'margin-bottom:0px' : ''" :class="printmode ? 'print' : ''">
            <div class="profile-left">
              <div class="profile-img-area" :class="tabs != 'summary' ? 'minimize' : ''">
                <div class="profile-img-wrap">
                  <el-tooltip placement="bottom">
                    <div slot="content" style="font-size:10px">
                      お気に入り<span>{{ profile_data.favorite == 0 ? "に追加" : "から削除" }}</span>
                    </div>
                    <div class="profile-img-favorite" :class="[tabs != 'summary' ? 'minimize' : '', profile_data.favorite == 0 ? 'off' : '']" @click="favorite">
                      <font-awesome-icon icon="star" />
                    </div>
                  </el-tooltip>
                  <el-image class="profile_img instagram" :class="tabs != 'summary' ? 'minimize' : ''" :src="profile_data.profile_picture_url">
                    <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
                  </el-image>
                  <!-- <div class="profile-img-sns instagram">
                    <font-awesome-icon :icon="['fab', 'instagram']"/>
                  </div> -->
                </div>
              </div>
              <div class="profile-gender-area" v-show="profile_data.private != 1 && (tabs == 'summary' || tabs == 'analysis')">
                <div class="profile-title">
                  フォロワーの男女比率
                  <el-tooltip placement="top">
                    <div slot="content">AIにより算出したフォロワーの男女比です。<br />実際の数値とは異なる場合があります。<br />またフォロワーの性別データが不十分な場合は表示されません。</div>
                    <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" :class="printmode ? 'printmode' : ''" />
                  </el-tooltip>
                </div>

                <div v-if="view_influencer_audience_enabled" >
                  <el-radio-group v-show="profile_data.audience" v-model="graph_gender" size="mini" style="margin-bottom: 10px;">
                    <el-radio-button label="全て"></el-radio-button>
                    <el-radio-button label="女性"></el-radio-button>
                    <el-radio-button label="男性"></el-radio-button>
                  </el-radio-group>

                  <genderBar :profile_data="profile_data" :graph_gender="graph_gender"/>
                </div>
                <div v-else>
                  <div class="activate-popover">
                    <div class="pointer" @click="toSetting">アップグレード</div>
                    でご利用いただけます
                  </div>
                </div>
              </div>
              <div class="profile-area-area" v-show="profile_data.private != 1 && (tabs == 'summary' || tabs == 'analysis')" :class="printmode ? 'printmode' : ''">
                <div class="profile-title">
                  関連エリア
                  <el-tooltip placement="top">
                    <div slot="content">
                      投稿画像やプロフィールから分析・算出を行った関連エリアです。<br />()内の数値は関連度を示しています。 <br />関連エリアは所在地を保証するものではありません。
                    </div>
                    <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                  </el-tooltip>
                </div>
                <div v-if="profile_data.related_area">
                  <div class="area-bar">
                    <div v-for="(area, index) in profile_data.related_area.area_data" :key="area.area_name" :class="'area-' + index + '-box'" :style="{ height: area.area_ratio / 3 + 'px' }">
                      <div class="area-box-name">
                        <span style="font-weight:700">{{ area.area_name }}</span>
                        <span style="font-size:8px">({{ area.area_ratio }}%)</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="no-data" v-else>データがありません</div>
              </div>
            </div>
            <div class="profile-right">
              <div class="profile-username">
                <div class="profile-username-box accountname" :class="tabs != 'summary' ? 'minimize' : ''">
                  <div style="display:flex; flex-flow:row; align-items:center">
                    {{ profile_data.account_name }}&nbsp;&nbsp;
                    <img src="../../assets/badge.png" style="width:20px; height:20px; margin-left:5px" v-show="profile_data.badge == 1" />
                    <el-tooltip content="[Adminメニュー] ユーザー名をコピー" placement="top" :disabled="activate != 20 || !admin_mode">
                      <font-awesome-icon
                        v-if="activate == 20 && admin_mode"
                        class="admin-button pointer"
                        :icon="['far', 'copy']"
                        style="margin: 0 10px;"
                        @click="copyLinkName(profile_data.account_name)"
                      />
                    </el-tooltip>
                    <el-tooltip content="[Adminメニュー] データ取得コードをコピー" placement="top" :disabled="activate != 20 || !admin_mode">
                      <font-awesome-icon v-if="activate == 20 && admin_mode" class="admin-button pointer" :icon="['far', 'code']" @click="copyGetLink(profile_data.account_name)" />
                    </el-tooltip>
                  </div>
                  <div class="profile-sort-keyword-wrap">
                    <div v-if="search_type == 'gender_check' && tabs == 'post'" class="flex-row">
                      <div class="profile-sort-keyword pointer" v-for="keyword in profile_data.keyword_list" :key="keyword.label" @click="searchMedia('gender_check', keyword.value)">
                        {{ keyword.label }}({{ keyword.count }})
                      </div>
                    </div>
                    <div v-else-if="search_type != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      「{{ formattedSearchKeyword }}」の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="searchMedia('all', '')" />
                    </div>
                    <div v-show="sort_period != 'all' && tabs == 'post'" class="profile-sort-keyword">
                      {{ sort_period == "1month" ? "直近1ヶ月" : sort_period == "3month" ? "直近3ヶ月" : sort_period == "6month" ? "直近6ヶ月" : "" }}の投稿
                      <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#333" class="pointer" @click="sortMediaBy('timestamp', 'all', '投稿日が新しい順')" />
                    </div>
                  </div>
                </div>

                <div class="profile-username-box" :class="printmode ? 'printmode-opacity' : ''">
                  <storiesButton :ig_id="ig_id" :stories.sync="profile_data.stories" :tracking_num="profile_data.tracking_num" :activate="activate" @storiesReactive="storiesReactive" />
                  <addListDetail
                    ref="add_list_detail"
                    :influencer_id="profile_data.ig_id"
                    :list_count="profile_data.list_count"
                    :add_delete_index="add_delete_index"
                    :add_delete_loading="add_delete_loading"
                    :sns_type="'instagram'"
                    @addInfluencer="addInfluencer"
                    @deleteInfluencer="deleteInfluencer"
                  />
                  <el-tooltip placement="top">
                    <div v-if="connect_ig_account_limit_num > 0" slot="content">
                      DMを送信
                    </div>
                    <div v-else class="activate-popover" slot="content">
                      <div class="pointer" @click="toSetting">アップグレード</div>
                      でご利用いただけます
                    </div>
                    <el-button type="info" style="margin-left:10px;" @click="connect_ig_account_limit_num > 0 ? openMessageDrawer() : null">
                      <font-awesome-icon style="font-size:14px" :icon="['fal', 'envelope']" />
                    </el-button>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Instagramでアカウントを表示">
                    <el-button type="info" style="margin-left:10px;" @click="openInstagram()">
                      <font-awesome-icon :icon="['fab', 'instagram']" style="font-size:14px" />
                    </el-button>
                  </el-tooltip>
                </div>
              </div>
              <div class="profile_follower" v-show="tabs == 'summary' || tabs == 'analysis'" :class="printmode ? 'print' : ''">
                <div class="profile_num followers" :class="printmode ? 'print' : ''">
                  <div class="num_title">フォロワー数</div>
                  <div>
                    <span class="num">{{ profile_data.followers }}</span
                    >万人
                  </div>
                  <div class="num_bar" :class="printmode ? 'printmode' : ''">
                    <div class="num_bar_power" :style="'width:' + (profile_data.followers * 100) / 20 + '%'"></div>
                  </div>
                </div>
                <div class="profile_num egr" :class="printmode ? 'print' : ''">
                  <div class="num_title">
                    平均EGR
                    <el-tooltip placement="top" :class="printmode ? 'printmode' : ''">
                      <div slot="content">
                        直近{{ analysis_span }}日の1投稿あたりの平均エンゲージメント率(EngagementRate)を示しています。 <br />いいね数とコメント数の合計をフォロワー数で割った比率です。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num" v-show="analysis_span == 90">{{ profile_data.average_engagement_rate }}</span>
                    <span class="num" v-show="analysis_span == 30">{{ profile_data.average_engagement_rate_1month }}</span>
                    %
                  </div>
                  <div class="num_bar" :class="printmode ? 'printmode' : ''">
                    <div class="num_bar_power" :style="'width:' + (profile_data.average_engagement_rate * 100) / 4 + '%'" :class="profile_data.average_engagement_rate < 1.5 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div class="profile_num like" :class="printmode ? 'print' : ''">
                  <div class="num_title">
                    平均いいね
                    <el-tooltip placement="top" :class="printmode ? 'printmode' : ''">
                      <div slot="content">
                        直近{{ analysis_span }}日の1投稿あたりの平均いいね数を示しています。
                      </div>
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <template v-if="analysis_span == 90">
                      <span class="num">{{ averageLikeFormat(profile_data.average_like) }}</span>
                      <span>{{ profile_data.average_like >= 10000 ? '万件' : '件' }}</span>
                    </template>
                    <template v-else-if="analysis_span == 30">
                      <span class="num">{{ averageLikeFormat(profile_data.average_like_1month) }}</span>
                      <span>{{ profile_data.average_like_1month >= 10000 ? '万件' : '件' }}</span>
                    </template>
                  </div>
                  <div class="num_bar" :class="printmode ? 'printmode' : ''">
                    <div
                        class="num_bar_power"
                        :style="{width: Math.min(100,Math.max(0,(((analysis_span == 90 ? Number(profile_data.average_like) : Number(profile_data.average_like_1month)) || 0) * 100) / 3000)) + '%'}"
                        :class="((analysis_span == 90 ? Number(profile_data.average_like) : Number(profile_data.average_like_1month)) || 0) < 200 ? 'danger' : ''"
                    ></div>
                  </div>
                </div>
                <div class="profile_num comment" :class="printmode ? 'print' : ''">
                  <div class="num_title">
                    平均コメント
                    <el-tooltip placement="top" :content="'直近の' + analysis_span + '日の1投稿あたりの平均コメント数を示しています。'" :class="printmode ? 'printmode' : ''">
                      <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="num" v-show="analysis_span == 90">{{ profile_data.average_comments }}</span>
                    <span class="num" v-show="analysis_span == 30">{{ profile_data.average_comments_1month }}</span>
                    件
                  </div>
                  <div class="num_bar" :class="printmode ? 'printmode' : ''">
                    <div class="num_bar_power" :style="'width:' + (profile_data.average_comments * 100) / 50 + '%'" :class="profile_data.average_comments < 10 ? 'danger' : ''"></div>
                  </div>
                </div>
                <div style="display:flex; flex-flow:row; width:100%">
                  <div class="profile_num reel_num" :class="printmode ? 'print' : ''">
                    <div class="num_title">
                      平均リール再生数
                      <el-tooltip placement="top" :content="'直近の' + analysis_span + '日の1リール投稿あたりの平均再生数です。直近3か月間でリール投稿がない場合は0となります。'" :class="printmode ? 'printmode' : ''">
                        <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                      </el-tooltip>
                    </div>
                    <div class="reel_average_video_play_count">
                      <div class="reel_num_total">
                        合計
                        <div>
                          <span class="num" v-show="analysis_span == 90">{{ String(profile_data.average_video_play_count / 10000).substring(0,5) }}</span>
                          <!-- <span class="num" v-show="analysis_span == 30">{{ String(profile_data.average_video_play_count_1month / 10000).substring(0,5) }}</span> -->
                          万回
                        </div>
                        <div class="num_bar" :class="printmode ? 'printmode' : ''">
                          <div class="num_bar_power" :style="'width:' + (profile_data.average_video_play_count * 100) / 50 + '%'" :class="profile_data.average_video_play_count < 10 ? 'danger' : ''"></div>
                        </div>
                      </div>
                      <span class="slash">&nbsp;&nbsp;(&nbsp;&nbsp;</span>
                      <div class="reel_num_organic video-detail-align">
                        ｵｰｶﾞﾆｯｸ
                        <div>
                          <span class="num" v-show="analysis_span == 90">{{ String(profile_data.average_video_play_count_organic / 10000).substring(0,5) }}</span>
                          <!-- <span class="num" v-show="analysis_span == 30">{{ String(profile_data.average_video_play_count_1month / 10000).substring(0,5) }}</span> -->
                        </div>
                        <div class="num_bar" :class="printmode ? 'printmode' : ''">
                          <div class="num_bar_power" :style="'width:' + (profile_data.average_video_play_count_organic * 100) / 50 + '%'" :class="profile_data.average_video_play_count_organic < 10 ? 'danger' : ''"></div>
                        </div>
                      </div>
                      <span class="slash">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                      <div class="reel_num_pr video-detail-align">
                        PR
                        <div class="">
                          <span class="num" v-show="analysis_span == 90">{{ String(profile_data.average_video_play_count_pr / 10000).substring(0,5) }}</span>
                          <!-- <span class="num" v-show="analysis_span == 30">{{ String(profile_data.average_video_play_count_1month / 10000).substring(0,5) }}</span> -->
                        </div>
                        <div class="num_bar" :class="printmode ? 'printmode' : ''">
                          <div class="num_bar_power" :style="'width:' + (profile_data.average_video_play_count_pr * 100) / 50 + '%'" :class="profile_data.average_video_play_count_pr < 10 ? 'danger' : ''"></div>
                        </div>
                      </div>
                      <span class="slash">&nbsp;&nbsp;)&nbsp;&nbsp;</span>
                    </div>
                  </div>
                  <div class="profile_num reel_percent" :class="printmode ? 'print' : ''">
                    <div class="num_title">
                      平均リール視聴率
                      <el-tooltip placement="top" :content="''" :class="printmode ? 'printmode' : ''">
                        <div slot="content">平均リール再生数をフォロワー数で割った比率です。<br>100%を超える場合は注目されている動画を投稿している可能性があります。</div>
                        <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                      </el-tooltip>
                    </div>
                    <div class="reel_average_video_play_count">
                      <div class="reel_num_total">
                        合計
                        <div>
                          <span class="num" v-show="analysis_span == 90">{{ profile_data.average_video_play_rate }}</span>
                          %
                          <!-- <span class="num" v-show="analysis_span == 30">{{ profile_data.average_video_play_rate_1month }}</span> -->
                        </div>
                        <div class="num_bar" :class="printmode ? 'printmode' : ''">
                          <div class="num_bar_power" :style="'width:' + profile_data.average_video_play_rate + '%'" :class="profile_data.average_video_play_rate < 10 ? 'danger' : ''"></div>
                        </div>
                      </div>
                      <span class="slash">&nbsp;&nbsp;(&nbsp;&nbsp;</span>
                      <div class="reel_num_organic video-detail-align">
                        ｵｰｶﾞﾆｯｸ
                        <div>
                          <span class="num" v-show="analysis_span == 90">{{ profile_data.average_video_play_rate_organic }}</span>
                          <!-- <span class="num" v-show="analysis_span == 30">{{ profile_data.average_video_play_rate_1month }}</span> -->
                        </div>
                        <div class="num_bar" :class="printmode ? 'printmode' : ''">
                          <div class="num_bar_power" :style="'width:' + profile_data.average_video_play_rate_organic + '%'" :class="profile_data.average_video_play_rate_organic < 10 ? 'danger' : ''"></div>
                        </div>
                      </div>
                      <span class="slash">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                      <div class="reel_num_pr video-detail-align">
                        PR
                        <div>
                          <span class="num" v-show="analysis_span == 90">{{ profile_data.average_video_play_rate_pr }}</span>
                          <!-- <span class="num" v-show="analysis_span == 30">{{ profile_data.average_video_play_rate_1month }}</span> -->
                        </div>
                        <div class="num_bar" :class="printmode ? 'printmode' : ''">
                          <div class="num_bar_power" :style="'width:' + profile_data.average_video_play_rate_pr + '%'" :class="profile_data.average_video_play_rate_pr < 10 ? 'danger' : ''"></div>
                        </div>
                      </div>
                      <span class="slash">&nbsp;&nbsp;)&nbsp;&nbsp;</span>
                    </div>
                  </div>
                </div>
                <div style="display:flex; flex-flow:row; width:100%">
                  <div class="profile_num pr_rate" :class="printmode ? 'print' : ''" v-show="tabs == 'summary' || tabs == 'analysis' ">
                    <div class="num_title">
                      PR率
                      <el-tooltip placement="top" :class="printmode ? 'printmode' : ''">
                        <div slot="content">直近{{ analysis_span }}日の投稿に占めるPR投稿の比率です。<br />20%を超えるとPR・広告色が強い印象を受ける可能性が高まります。</div>
                        <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                      </el-tooltip>
                    </div>
                    <div>
                      <span class="num" v-show="analysis_span == 90">{{ profile_data.pr_rate }}</span>
                      <span class="num" v-show="analysis_span == 30">{{ profile_data.pr_rate_1month }}</span>
                      %
                      <div class="num_bar" :class="printmode ? 'printmode' : ''">
                        <div v-show="analysis_span == 90" class="num_bar_power" :style="'width:' + (100 - profile_data.pr_rate * 3) + '%'" :class="profile_data.pr_rate > 25 ? 'danger' : ''"></div>
                        <div
                            v-show="analysis_span == 30"
                            class="num_bar_power"
                            :style="'width:' + (100 - profile_data.pr_rate_1month * 3) + '%'"
                            :class="profile_data.pr_rate_1month > 25 ? 'danger' : ''"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="profile_num followers" :class="printmode ? 'print' : ''" v-show="tabs == 'analysis' ">
                    <div class="num_title">
                      フォロワー増加率
                      <el-tooltip placement="top" :content="'直近' + analysis_span + '日のフォロワー増加率を示しています。'" :class="printmode ? 'printmode' : ''">
                        <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                      </el-tooltip>
                    </div>
                    <div v-show="analysis_span == 90">
                      <span v-if="profile_data.followers_growth_rate_90 > 0">+ </span>
                      <span class="num">{{ profile_data.followers_growth_rate_90 | growthrate }}</span>
                      %
                    </div>
                    <div v-show="analysis_span == 30">
                      <span v-if="profile_data.followers_growth_rate_30 > 0">+ </span>
                      <span class="num">{{ profile_data.followers_growth_rate_30 | growthrate }}</span>
                      %
                    </div>
                    <div class="num_bar" :class="printmode ? 'printmode' : ''">
                      <div class="num_bar_power" :style="'width:' + (profile_data.followers_growth_rate_90 * 100) / 10 + '%'" :class="profile_data.followers_growth_rate_90 < 0 ? 'danger' : ''"></div>
                    </div>
                  </div>
                  <div class="profile_num" :class="printmode ? 'print' : ''" v-show="tabs == 'analysis' ">
                    <div class="num_title">
                      平均EGR<br/>(PR投稿のみ)
                      <el-tooltip placement="top" :class="printmode ? 'printmode' : ''">
                        <div slot="content">
                          直近{{ analysis_span }}日のPR投稿1投稿あたりの平均エンゲージメント率(EngagementRate)を示しています。 <br />いいね数とコメント数の合計をフォロワー数で割った比率です。
                        </div>
                        <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                      </el-tooltip>
                    </div>
                    <div>
                      <span class="num" v-show="analysis_span == 90">{{ profile_data.average_engagement_rate_only_pr != 0 ? profile_data.average_engagement_rate_only_pr : "N/A" }}</span>
                      <span class="num" v-show="analysis_span == 30">{{ profile_data.average_engagement_rate_only_pr_1month != 0 ? profile_data.average_engagement_rate_only_pr_1month : "N/A" }}</span>
                      %
                    </div>
                    <div class="num_bar" :class="printmode ? 'printmode' : ''">
                      <div
                        v-show="analysis_span == 90"
                        class="num_bar_power"
                        :style="'width:' + (profile_data.average_engagement_rate_only_pr * 100) / 4 + '%'"
                        :class="profile_data.average_engagement_rate_only_pr < 1.5 ? 'danger' : ''"
                      ></div>
                      <div
                        v-show="analysis_span == 30"
                        class="num_bar_power"
                        :style="'width:' + (profile_data.average_engagement_rate_only_pr_1month * 100) / 4 + '%'"
                        :class="profile_data.average_engagement_rate_only_pr_1month < 1.5 ? 'danger' : ''"
                      ></div>
                    </div>
                  </div>
                  <div class="profile_num" :class="printmode ? 'print' : ''" v-show="tabs == 'analysis' ">
                    <div class="num_title">
                      投稿頻度
                      <el-tooltip placement="top" :content="'直近' + analysis_span + '日の投稿頻度を示しています。'" :class="printmode ? 'printmode' : ''">
                        <font-awesome-icon icon="question-circle" style="margin-left:5px; color:#666;" />
                      </el-tooltip>
                    </div>
                    <div>
                      <span class="num">{{ profile_data.media_frequency | frequency }}</span
                      >件/週
                    </div>
                    <div class="num_bar" :class="printmode ? 'printmode' : ''">
                      <div class="num_bar_power" :style="'width:' + (profile_data.media_frequency / 7) * 100 + '%'" :class="profile_data.media_frequency < 2 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <div v-show="tabs == 'analysis'" style="display:flex; flex-flow:row; width:100%">
                  <div class="profile_num total_post" :class="printmode ? 'print' : ''">
                    <div class="num_title">
                      総投稿数
                    </div>
                    <div>
                      <span class="num">{{ profile_data.media_count }}</span
                      >件
                    </div>
                    <div class="num_bar" :class="printmode ? 'printmode' : ''">
                      <div class="num_bar_power" :style="'width:' + profile_data.media_count / 20 + '%'" :class="profile_data.media_count < 50 ? 'danger' : ''"></div>
                    </div>
                  </div>
                </div>
                <!-- <div style="position:absolute; right: 10px; top:10px; font-size:10px; color:#666">
                  <el-dropdown trigger="click">
                    <el-button size="mini" style="padding:5px">
                      {{ analysis_span }}日
                      <font-awesome-icon :icon="['fas', 'caret-down']" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="analysis_span = 30">
                        <div class="flex-row">
                          <div class="window-switch-check">
                            <font-awesome-icon :icon="['fas', 'check']" v-show="analysis_span == 30" />
                          </div>
                          <div>30日</div>
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="analysis_span = 90">
                        <div class="flex-row">
                          <div class="window-switch-check">
                            <font-awesome-icon :icon="['fas', 'check']" v-show="analysis_span == 90" />
                          </div>
                          <div>90日</div>
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div> -->
              </div>
              <div class="profile-right-center">
                <!-- スコアアラート -->
                <div class="profile-score-alert-wrap" v-show="(tabs == 'analysis' || tabs == 'summary')&& profile_data.score_alert">
                  <scoreAlert :profile_data="profile_data" :tabs="tabs"/>
                </div>
                <div class="flex-space"></div>
                <!-- スコアボード -->
                <div class="profile-score-area" v-show="(tabs == 'summary' || tabs == 'analysis')" :class="printmode ? 'printmode' : ''">
                  <scoreBord :profile_data="profile_data" />
                </div>
              </div>
              <div class="profile-right-center">
                <div class="profile-name-area" v-show="tabs == 'summary'">
                  <div class="profile_name">
                    <div class="profile-feature" v-if="profile_data.name">
                      <b>{{ profile_data.name }}</b>
                      <span style="margin:0 10px" v-if="profile_data.age || profile_data.gender == '男性' || profile_data.gender == '女性'">|</span>
                    </div>
                    <div class="profile-feature" v-if="profile_data.age">
                      {{ profile_data.age }}歳
                      <el-tooltip :class="printmode ? 'printmode' : ''">
                        <div slot="content">過去の投稿やWebの情報から推測される年齢です。<br />実際の年齢と異なる場合があります。</div>
                        <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
                      </el-tooltip>
                      <span style="margin:0 10px">|</span>
                    </div>
                    <div class="profile-feature" v-if="profile_data.gender == '男性' || profile_data.gender == '女性'">
                      <span v-if="profile_data.gender == '女性'"><font-awesome-icon :icon="['fas', 'female']" style="color:#f56c6c; margin-right: 5px;" />女性</span>
                      <span v-if="profile_data.gender == '男性'"><font-awesome-icon :icon="['fas', 'male']" style="color:#0095f6; margin-right: 5px;" />男性</span>
                    </div>
                  </div>

                  <div class="profile_bio">
                    <pre>{{ profile_data.biography }}</pre>
                  </div>
                  <div>
                    <a :href="profile_data.website" v-show="profile_data.website" target="_blank">
                      <span class="profile_website pointer" target="_blank">{{ profile_data.website }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="profile-bottom" v-show="profile_data.private != 1 && (tabs == 'summary' || tabs == 'post') && media_type != 'stories'" :class="printmode ? 'printmode' : ''">
            <div class="first-row">
              <div class="profile-left tagarea">
                <div class="profile-title">
                  関連カテゴリ
                  <el-tooltip placement="top">
                    <div slot="content">投稿画像やキャプションから分析・算出を行った関連カテゴリーです。<br />()内の数値は関連度を示しています。</div>
                    <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                  </el-tooltip>
                </div>
                <div v-if="profile_data.category" class="category-box-wrap">
                  <div class="category-box pointer" v-for="category in profile_data.category.category_data" :key="category.category_name" @click="searchMedia('category', category.category_name)">
                    <font-awesome-icon icon="tag" style="margin-right:1px; font-size:10px" />
                    {{ category.category_name }}<span style="font-size: 10px">({{ category.category_ratio | decimal }}%)</span>
                  </div>
                </div>
                <div class="no-data" v-else>データがありません</div>
              </div>
              <div class="profile-right tagarea">
                <div class="hashtag-area">
                  <div class="profile-title">
                    ハッシュタグTOP20
                    <el-tooltip placement="top" content="直近の投稿で使われることが多いハッシュタグです。">
                      <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                    </el-tooltip>
                  </div>
                  <div
                    class="hashtag-box pointer"
                    :class="'hashtag-box-' + hash_index"
                    v-for="(hashtag, hash_index) in profile_data.hashtag"
                    :key="hashtag"
                    @click="searchMedia('hashtag', '#' + hashtag)"
                  >
                    #{{ hashtag }}
                  </div>
                </div>
              </div>
            </div>
            <!-- マッピング -->
            <div class="second-row" v-if="(profile_data.attribute_person_title && profile_data.attribute_person_title.length) || (profile_data.attribute_specialty_categories_genres && profile_data.attribute_specialty_categories_genres.length) || (profile_data.attribute_post_format && profile_data.attribute_post_format.length)">
              <div class="mapping-container">
                <div class="mapping">
                  マッピング
                  <el-tooltip placement="top" content="プロフィールや投稿内容から分析を行った分類です。分析結果が無いマッピング情報は表示されません。">
                    <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                  </el-tooltip>
                </div>
                <div class="attribute-table">
                    <div class="attribute-row">
                        <!-- 人物・肩書 -->
                        <div class="attribute-cell" v-if="profile_data.attribute_person_title && profile_data.attribute_person_title.length">
                          <div class="attribute-area">
                            <div class='attribute-title'>
                              人物・肩書
                              <el-tooltip placement="top" content="人物・肩書のマッピングです。">
                                <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                              </el-tooltip>
                            </div>
                            <div
                                class="attribute-box pointer"
                                :class="'attribute-box-' + attribute_index"
                                v-for="(person_title, attribute_index) in profile_data.attribute_person_title"
                                :key="attribute_index"
                            >
                              {{ person_title.property_name }}
                            </div>
                        </div>
                      </div>
                      <!-- 得意カテゴリー・ジャンル -->
                      <div class="attribute-cell" v-if="profile_data.attribute_specialty_categories_genres && profile_data.attribute_specialty_categories_genres.length">
                        <div class="attribute-area">
                          <div class='attribute-title'>
                            得意カテゴリー・ジャンル
                            <el-tooltip placement="top" content="得意カテゴリー・ジャンルのマッピングです。">
                              <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                            </el-tooltip>
                          </div>
                          <div
                              class="attribute-box pointer"
                              :class="'attribute-box-' + attribute_index"
                              v-for="(specialty_categories_genres, attribute_index) in profile_data.attribute_specialty_categories_genres"
                              :key="attribute_index"
                          >
                            {{ specialty_categories_genres.property_name }}
                          </div>
                        </div>
                      </div>
                      <!-- 投稿形式 -->
                      <div class="attribute-cell" v-if="profile_data.attribute_post_format && profile_data.attribute_post_format.length">
                        <div class="attribute-area">
                          <div class='attribute-title'>
                            投稿形式
                            <el-tooltip placement="top" content="投稿形式のマッピングです。">
                              <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" />
                            </el-tooltip>
                          </div>
                          <div
                              class="attribute-box pointer"
                              :class="'attribute-box-' + attribute_index"
                              v-for="(post_format, attribute_index) in profile_data.attribute_post_format"
                              :key="attribute_index"
                          >
                            {{ post_format.property_name }}
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="search-form-instagram" v-show="media_type == 'feed' || media_type == 'reel'" style="justify-content: flex-end;">            
            <div v-show="tabs == 'post' && post_count > 0">
              <el-pagination
                  @current-change="currentChange"
                  :current-page="media_type == 'feed' || media_type == 'reel' ? currentPage : currentPage_stories"
                  background
                  layout="prev, pager, next"
                  :total="media_type == 'feed' ? post_count : media_type == 'reel' ? post_count_reel : post_count_stories"
                  :page-size="pagesize"
                  :pager-count="5"
                  small
              ></el-pagination>
            </div>          
          </div>

          <div class="search-form-instagram" v-show="tabs == 'post'">
            <selectButton :has_stories="profile_data.stories" :media_type.sync="media_type" />
            <div class="header-search-wrap instagram" style="width: 180px; margin-right: 10px" :style="inputfocus ? 'width: 100%' : ''">
              <font-awesome-icon :icon="['fas', 'search']" style="font-size:16px; color:#aaa; margin-right:10px" />
              <postSearchInput :inputfocus.sync="inputfocus" :inputkeyword.sync="inputkeyword" :media_type="media_type" @searchKeyword="searchKeyword('keyword', inputkeyword)" />
            </div>
            <div class="flex-row">              
              <datePicker 
                v-show="media_type == 'feed' || media_type == 'reel'" 
                :searchGraphPostPeriod="searchGraphPostPeriod"
                @date-change="searchPostPeriodChange" 
              />
              <div class="flex-row" v-show="media_type == 'feed' || media_type == 'reel'">
                <el-checkbox :value="search_type == 'pr'" @change="search_type == 'pr' ? searchMedia('all', '') : searchMedia('pr', 'PR投稿')" style="display:flex; align-items:center;">
                  <el-tooltip placement="bottom">
                    <div slot="content">「#PR」などのPR表記のある投稿のみを表示します。</div>
                    <span style="font-size:11px; color:#666; ">PR投稿のみを表示</span>
                  </el-tooltip>
                </el-checkbox>
                <el-checkbox
                  v-model="request_pr"
                  @change="searchMedia('request_pr', 'このブランドが依頼したPR案件')"
                  style="display:flex; align-items:center;"
                  v-if="parent_component == 'admin' && admin_mode"
                >
                  <span style="font-size:11px; color:#aaa; ">このブランドが依頼したPR案件を表示</span>
                </el-checkbox>
                <el-dropdown trigger="click" style="margin-left: 20px">
                  <el-button type="info" class="report-media-sort-button">
                    {{ media_sort }}
                    <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px" />
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :class="media_sort == '投稿日が新しい順' ? 'assign' : ''"
                      :disabled="media_sort == '投稿日が新しい順'"
                      @click.native="sortMediaBy('timestamp', 'all', '投稿日が新しい順')"
                      >投稿日が新しい順</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'EGが多い順(直近1ヶ月)' ? 'assign' : ''"
                      :disabled="media_sort == 'EGが多い順(直近1ヶ月)'"
                      @click.native="sortMediaBy('engagement_count', '1month', 'EGが多い順(直近1ヶ月)')"
                      >EGが多い順(直近1ヶ月)</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'EGが多い順(直近3ヶ月)' ? 'assign' : ''"
                      :disabled="media_sort == 'EGが多い順(直近3ヶ月)'"
                      @click.native="sortMediaBy('engagement_count', '3month', 'EGが多い順(直近3ヶ月)')"
                      >EGが多い順(直近3ヶ月)</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'EGが多い順(直近6ヶ月)' ? 'assign' : ''"
                      :disabled="media_sort == 'EGが多い順(直近6ヶ月)'"
                      @click.native="sortMediaBy('engagement_count', '6month', 'EGが多い順(直近6ヶ月)')"
                      >EGが多い順(直近6ヶ月)</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'EGが多い順(全期間)' ? 'assign' : ''"
                      :disabled="media_sort == 'EGが多い順(全期間)'"
                      @click.native="sortMediaBy('engagement_count', 'all', 'EGが多い順(全期間)')"
                      >EGが多い順(全期間)</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'コメントが多い順(直近1ヶ月)' ? 'assign' : ''"
                      :disabled="media_sort == 'コメントが多い順(直近1ヶ月)'"
                      @click.native="sortMediaBy('comments_count', '1month', 'コメントが多い順(直近1ヶ月)')"
                      >コメントが多い順(直近1ヶ月)</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'コメントが多い順(直近3ヶ月)' ? 'assign' : ''"
                      :disabled="media_sort == 'コメントが多い順(直近3ヶ月)'"
                      @click.native="sortMediaBy('comments_count', '3month', 'コメントが多い順(直近3ヶ月)')"
                      >コメントが多い順(直近3ヶ月)</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'コメントが多い順(直近6ヶ月)' ? 'assign' : ''"
                      :disabled="media_sort == 'コメントが多い順(直近6ヶ月)'"
                      @click.native="sortMediaBy('comments_count', '6month', 'コメントが多い順(直近6ヶ月)')"
                      >コメントが多い順(直近6ヶ月)</el-dropdown-item
                    >
                    <el-dropdown-item
                      :class="media_sort == 'コメントが多い順(全期間)' ? 'assign' : ''"
                      :disabled="media_sort == 'コメントが多い順(全期間)'"
                      @click.native="sortMediaBy('comments_count', 'all', 'コメントが多い順(全期間)')"
                      >コメントが多い順(全期間)</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>

          <!-- 投稿リスト部分 -->
          <storiesList
            :tabs="tabs"
            :stories_list="stories_list"
            :no_media_message_stories="no_media_message_stories"
            v-if="media_type == 'stories' && tabs == 'post'"
            @showStories="showStories()"
            @detail="detail"
          />

          <reelList
            :profile_data="profile_data"
            :post_data="post_data_reel"
            :post_count="post_count_reel"
            :no_media_message="no_media_message"
            :tabs="tabs"
            @currentPage="pageChange(1, 'reel')"
            @detail="detail"
            @imgReelError="imgReelError"
            @imgReelLoaded="imgReelLoaded"
            v-else-if="media_type == 'reel' && tabs == 'post'"
          />

          <postList
            :profile_data="profile_data"
            :post_data="post_data"
            :post_count="post_count"
            :no_media_message="no_media_message"
            :tabs="tabs"
            @detail="detail"
            @imgError="imgError"
            @imgLoaded="imgLoaded"
            v-else
          />

          <div class="pagenation-wrap" v-show="profile_data.private != 1 && (tabs == 'summary' || tabs == 'post')">
            <el-pagination
              @current-change="currentChange"
              :current-page="media_type == 'feed' || media_type == 'reel' ? currentPage : currentPage_stories"
              background
              layout="prev, pager, next"
              :total="media_type == 'feed' ? post_count : media_type == 'reel' ? post_count_reel : post_count_stories"
              :page-size="pagesize"
            ></el-pagination>
          </div>

          <!-- 投稿詳細 -->
          <postDetail
            :drawer="drawer"
            :post_data="detail_data"
            :pr_word="pr_word"
            :profile_data="profile_data"
            :search_keyword="search_keyword"
            :search_type="search_type"
            @closeDrawer="closeDrawer"
          />

          <!-- リール詳細 -->
          <reelDetail
            :reel_drawer="reel_drawer"
            :post_data="detail_data_reel"
            :pr_word="pr_word"
            :profile_data="profile_data"
            :search_keyword="search_keyword"
            :search_type="search_type"
            @closeDrawer="closeDrawer"
          />

          <!-- ストーリーズ詳細 -->
          <storiesDetail
            :stories_drawer="stories_drawer"
            :stories_data="stories_data"
            :pr_word="pr_word"
            :profile_data="profile_data"
            :search_keyword="search_keyword"
            :search_type="search_type"
            @closeDrawer="closeDrawer"
          />

          <!-- メッセージ -->
          <div class="overlay-sub" v-bind:class="[message_drawer ? 'overlay open' : 'overlay']" @click="closeMessageDrawer()"></div>
          <div v-bind:class="[message_drawer ? 'pr-detail-modal open' : 'pr-detail-modal']">
            <inboxDetail v-if="message_drawer" :ig_id="ig_id" referer="idetail" thread_id />
          </div>

          <!-- ノート -->
          <note
            v-if="tabs == 'note'"
            :id="ig_id"
            :sns_type="'instagram'"
            ref="note"
            @commentReactive="commentReactive"
            @statusReactive="statusReactive"
            @noteReactive="noteReactive"
            @tagReactive="tagReactive"
          />

          <!-- レポート -->
          <report
            v-if="tabs == 'report'"
            :id="ig_id"
            :sns_type="'instagram'"
            ref="note"
            @noteReactive="noteReactive"
          />


          <div v-observe-visibility="{ callback: similarVisible }"></div>

          <!-- フォロワー推移データ -->
          <transitionData :sns_type="'instagram'" :loading="loading" :id="ig_id" v-show="tabs == 'summary' || tabs == 'analysis'" 
          @update-data="selectPostPeriod"/>

          <!-- ワードクラウド -->
          <word-cloud
              :words="words"
              v-show="tabs == 'summary' || tabs == 'analysis'"
              @word-clicked="handleWordClicked"
          />

          <!-- EG推移 -->
          <transitionData :sns_type="'instagram_eg'" :loading="loading" :id="ig_id" v-show="tabs == 'summary' || tabs == 'analysis'" />

          <!-- エンゲージメント分布 -->
          <distributionChart
            :avg_data="egr_data"
            :name="account_name"
            :own_data="profile_data.average_engagement_rate"
            :type="'egr'"
            :sns_type="'instagram'"
            :followers="profile_data.followers_count"
            v-show="tabs == 'summary' || tabs == 'analysis'"
          />

          <div id="i-detail-similar"></div>

          <!-- 類似アカウント -->
          <similarAccount
            ref="similarAccount"
            v-if="similar_show"
            :similar_data="similar_data"
            :sns_type="'instagram'"
            @toInfluencerDetail="toInfluencerDetail"
            @toInfluencerDetailNewWindow="toInfluencerDetailNewWindow"
          />
        </div>
      </div>
    </div>
    <div class="loader-detail" v-show="!mounted || loading"></div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const showAPI = root + "/api/search/show";
const loadSimilarAccountAPI = root + "/api/search/load_similar";
const addInfluencerAPI = root + "/api/list/add_influencer";
const deleteInfluencerAPI = root + "/api/list/delete_influencer";
const addFavoriteAPI = root + "/api/list/add_favorite";
const changeDeleteFlagAPI = root + "/api/admin/change_delete_flag";
const showStoriesAPI = root + "/api/search/show_stories";
const loadListAPI = root + "/api/list/load_list";

import inboxDetail from "../message/inbox_detail.vue";
import transitionData from "./transitionData";
import postSearchInput from "./postSearchInput";
import note from "./note.vue";
import report from "./report.vue";
import postDetail from "./detail_component/post_detail";
import reelDetail from "./detail_component/reel_detail";
import genderBar from "./detail_component/gender_bar";
import postList from "./detail_component/post_list";
import reelList from "./detail_component/reel_list";
import addListDetail from "./detail_component/add_list_detail";
import similarAccount from "./detail_component/similar_account";
import distributionChart from "./detail_component/distribution_chart";
import otherSNS from "./other_sns.vue";
import storiesButton from "./stories_button";
import selectButton from "./detail_component/select_button";
import storiesList from "./stories_list.vue";
import storiesDetail from "./stories_detail.vue";
import scoreBord from "./scoreBord";
import scoreAlert from "./scoreAlert";
import wordCloud from "./word_cloud";
import datePicker from "./datePicker.vue";
import { handleApiResponse } from "@/components/common/responseHelper";

export default {
  name: "influencerDetail",
  components: {
    inboxDetail,
    transitionData,
    postSearchInput,
    note,
    report,
    postDetail,
    reelDetail,
    genderBar,
    postList,
    reelList,
    addListDetail,
    similarAccount,
    distributionChart,
    otherSNS,
    storiesButton,
    selectButton,
    storiesList,
    storiesDetail,
    scoreBord,
    scoreAlert,
    wordCloud,
    datePicker
  },
  beforeRouteLeave(to, from, next) {
    if (to.name.match(/influencerDetail/i)) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_influencerDetailDrawer" : "influencerDetail",
        params: {
          account_name: to.params.account_name,
          child: this.child == true ? true : false,
          parent_component: this.child == true ? this.parent_component : "",
        },
      });
    } else if (to.name == "youtuberDetail" && this.child) {
      this.$router.push({
        name: this.parent_component == "instagram" ? this.parent_component + "_youtuberDetailDrawer" : "youtuberDetail",
        params: {
          channel_id: to.params.channel_id,
          child: this.child == true ? true : false,
          parent_component: this.child == true ? this.parent_component : "",
        },
      });
    } else {
      next();
    }
  },
  props: {
    account_name: String,
    child: Boolean,
    parent_component: String,
    influencer_index: Number,
    default_search: Boolean,
  },
  data() {
    return {
      ig_id: "",
      currentPage: 1,
      currentPage_stories: 1,
      post_count: 0,
      post_count_reel: 0,
      post_count_stories: 0,
      pagesize: 28,
      profile_data: [],
      egr_data: [],
      post_data: [],
      post_data_reel: [],
      similar_data: [],
      similar_loading: true,
      no_media_message: "",
      no_media_message_stories: "",
      list: [],
      stories_list: [],
      active_list_count: "",
      checkList: [],
      search_type: "all",
      search_keyword: "",
      sort_key: "timestamp",
      sort_period: "all",
      media_sort: "投稿日が新しい順",
      request_pr: false,
      drawer: false,
      reel_drawer: false,
      stories_drawer: false,
      index: 0,
      mounted: false,
      loading: false,
      add_delete_loading: false,
      add_delete_index: "",
      detail_loading: false,
      click_loading: false,
      img_count: 0,
      img_reel_count: 0,
      inputfocus: false,
      inputkeyword: "",
      tagged_user: false,
      channel_id: "",
      requestId: +new Date(),
      requestId_similar: 100000 + new Date(),
      message_drawer: false,
      graphdetail_data: [],
      tabs: "summary",
      pr_word: "#pr|#promotion|#sponsored|#.+_pr|#.+_sponsored|#.+_ad|#.+_partner|#supported|#.+_supported",
      pr_word_without_hash: "pr|promotion|sponsored|.+_pr|.+_sponsored|.+_ad|.+_partner|supported|.+_supported", // # なし
      similar_show: false,
      analysis_span: 90,
      media_type: "feed",
      graph_gender: "全て",
      hashtagEgr: [],
      words: [],
      searchPeriodFrom: null,
      searchPeriodTo: null,
      searchGraphPostPeriod: [],
      printmode: false,
      actionId: Math.floor(new Date().getTime() / 1000),
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    i_search() {
      return this.$store.state.i_search;
    },
    sessionid() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.sessionid;
      } else {
        return null;
      }
    },
    csrftoken() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.csrftoken;
      } else {
        return null;
      }
    },
    textarea_rows() {
      var num = this.chat_value.split("\n").length;
      return num > 4 ? 5 : num > 1 ? num : 1;
    },
    textarea_height() {
      return this.textarea_rows * 16;
    },
    similar_account() {
      return this.similar_data.slice(0, 5);
    },
    detail_data() {
      return this.post_data[this.index];
    },
    detail_data_reel() {
      return this.post_data_reel[this.index];
    },
    stories_data() {
      return this.stories_list[this.index];
    },
    search_influencer_youtube_enabled() {
      return this.$store.state.service_plan.search_influencer_youtube_enabled;
    },
    search_influencer_tiktok_enabled() {
      return this.$store.state.service_plan.search_influencer_tiktok_enabled;
    },
    search_influencer_x_enabled() {
      return this.$store.state.service_plan.search_influencer_x_enabled;
    },
    connect_ig_account_limit_num() {
      return this.$store.state.service_plan.connect_ig_account_limit_num;
    },
    view_influencer_audience_enabled() {
      return this.$store.state.service_plan.view_influencer_audience_enabled;
    },
    formattedSearchKeyword() {
      if (this.search_type === 'category') {
        // 配列の場合のみ .map を実行
        return Array.isArray(this.search_keyword)
            ? this.search_keyword.map(item => item.slice(-1)[0]).join(' ')
            : this.search_keyword;
      }
      // 配列でない場合はそのまま返す
      return this.search_keyword || '';
    },
  },
  created() {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.img_count = 0;
      this.loading = true;
      if (this.$route.params.note) this.tabs = "note";
      if (this.default_search == true) {
        this.search_type = this.$route.params.search_type;
        this.search_keyword = this.$route.params.search_keyword;
        this.searchMedia(this.search_type, this.search_keyword, this.media_type);
        this.loadList();
      } else {
        this.axios
          .get(showAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              account_name: this.account_name,
              search_type: "all",
            },
          })
          .then((response) => {
            if (handleApiResponse(response)) {
              // ステータスがNGの場合
              this.$message.error(response.data.message);
              this.$nextTick(() => {
                this.$router.push({ name: 'influencer' });
              });
              return;
            }

            this.mounted = true;
            this.profile_data = response.data.profile_data;
            this.post_data = response.data.post_data;
            this.egr_data = response.data.egr_data;
            this.post_count = response.data.post_count;
            this.ig_id = response.data.profile_data.ig_id;
            this.hashtagEgr = response.data.hashtagEgr;
            this.setWordsFromHashTags();
            if (response.data.post_count == 0 || response.data.profile_data.private || response.data.profile_data.delete) {
              this.no_media_message = response.data.no_media_message;
              this.loading = false;
            }
            this.loadSimilarAccount();
          })
          .catch(() => {
            this.mounted = true;
            this.loading = false;
          });
      }
    },
    loadSimilarAccount() {
      this.axios.cancel(this.requestId_similar);
      this.requestId_similar += 1;
      this.similar_loading = true;
      this.axios
        .get(loadSimilarAccountAPI, {
          requestId: this.requestId_similar,
          params: {
            token: this.token,
            ig_id: this.ig_id,
          },
        })
        .then((response) => {
          this.similar_data = response.data.similar_data;
          this.similar_loading = false;
        })
        .catch(() => {});
    },
    similarVisible(isVisible) {
      if (isVisible && !this.similar_show) {
        this.similar_show = true;
      }
    },
    currentChange(currentPage) {
      if (this.media_type == "feed" || this.media_type == "reel") {
        this.pageChange(currentPage, this.media_type);
      } else if (this.media_type == "stories") {
        this.showStories(currentPage, this.search_keyword);
      }
    },
    pageChange(currentPage, post_type) {
      this.loading = true;
      this.currentPage = currentPage;
      this.requestId += 1;
      this.post_type = post_type;

      if (post_type ==='reel') {
        this.post_data_reel = [];
      } else {
        this.post_data = [];
      }

      this.axios
        .get(showAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            account_name: this.account_name,
            currentPage: this.currentPage,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
            post_type: this.post_type,
            search_period_from: this.searchPeriodFrom,
            search_period_to: this.searchPeriodTo
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'influencer' });
            });
            return;
          }

          this.profile_data = response.data.profile_data;

          if (post_type ==='reel') {
            this.post_data_reel = response.data.post_data;
            this.post_count_reel = response.data.post_count;
          } else {
            this.post_data = response.data.post_data;
            this.post_count = response.data.post_count;
          }

          this.egr_data = response.data.egr_data;
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
          this.loading = false;
        })
        .catch(() => {
          this.mounted = true;
          this.loading = false;
        });
    },
    searchKeyword(type, keyword) {
      if (this.media_type == "feed" || this.media_type == "reel") {
        this.searchMedia(type, keyword, this.media_type);
      } else if (this.media_type == "stories") {
        this.showStories(this.currentPage, keyword);
      }
    },
    searchMedia(type, keyword, post_type) {
      this.loading = true;
      this.click_loading = true;
      this.currentPage = 1;
      this.tabs = "post";
      if (this.search_type != type || this.search_keyword != keyword) {
        this.media_sort = "投稿日が新しい順";
        this.sort_key = "timestamp";
        this.sort_period = "all";
      }
      if (type !== "keyword") this.inputkeyword = "";
      if (type == "keyword" && keyword == "") type = "all";
      if (type == "gender_check") this.inputkeyword = keyword;
      if (post_type == null) post_type = this.media_type;
      this.search_type = type;
      this.search_keyword = keyword;
      this.requestId += 1;
      if (post_type ==='reel') {
        this.post_data_reel = [];
      } else {
        this.post_data = [];
      }
      this.axios
        .get(showAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            account_name: this.account_name,
            currentPage: 1,
            search_type: this.search_type,
            search_keyword: this.search_keyword,
            sort_key: this.sort_key,
            sort_period: this.sort_period,
            post_type: post_type,
            search_period_from: this.searchPeriodFrom,
            search_period_to: this.searchPeriodTo
          },
        })
        .then((response) => {
          this.loading = false;
          if (handleApiResponse(response)) {
            // ステータスがNGの場合
            this.$message.error(response.data.message);
            this.$nextTick(() => {
              this.$router.push({ name: 'influencer' });
            });
            return;
          }

          if (response.data.post_count == 0 || response.data.profile_data.private || response.data.profile_data.delete) {
            this.no_media_message = response.data.no_media_message;
          }
          this.mounted = true;
          this.profile_data = response.data.profile_data;
          this.egr_data = response.data.egr_data;
          this.post_count = response.data.post_count;
          this.ig_id = response.data.profile_data.ig_id;
          this.hashtagEgr = response.data.hashtagEgr;
          this.setWordsFromHashTags();

          if (post_type ==='reel') {
            this.post_data_reel = response.data.post_data;
            this.post_count_reel = response.data.post_count;
          } else {
            this.post_data = response.data.post_data;
            this.post_count = response.data.post_count;
          }

          if (type == "pr") this.pr_regexp = response.data.search_keyword;
          this.loadSimilarAccount();
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
        })
        .catch(() => {
          this.mounted = true;
          this.loading = false;
        });
    },
    sortMediaBy(sort_key, sort_period, sort_description) {
      this.sort_key = sort_key;
      this.sort_period = sort_period;
      this.media_sort = sort_description;
      this.searchMedia(this.search_type, this.search_keyword);
    },
    resetSearchMedia() {
      this.search_type = "all";
      this.search_keyword = "";
      this.sort_key = "timestamp";
      this.sort_period = "all";
      this.media_sort = "投稿日が新しい順";
      this.inputkeyword = "";
      this.currentPage = 1;
      this.searchPeriodFrom = "";
      this.searchPeriodTo = "";
      this.searchGraphPostPeriod = [];
    },
    showStories(currentPage = 1, keyword = null) {
      this.search_keyword = keyword;
      this.currentPage_stories = currentPage;
      this.loading = true;
      this.axios
        .get(showStoriesAPI, {
          params: {
            token: this.token,
            ig_id: this.ig_id,
            currentPage: this.currentPage_stories,
            search_keyword: keyword ? this.search_keyword : null,
          },
        })
        .then((response) => {
          this.stories_list = response.data.stories_list;
          this.post_count_stories = response.data.post_count;
          this.no_media_message_stories = response.data.no_media_message_stories;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    detail(index, type) {
      if (type == "feed") {
        this.drawer = true;
        this.index = index;
        this.detail_loading = true;
      } else if (type == "reel") {
        this.reel_drawer = true;
        this.index = index;
        this.detail_loading = true;
      } else if (type == "stories") {
        this.stories_drawer = true;
        this.index = index;
        this.detail_loading = true;
      }
    },
    loadList() {
      this.axios
          .get(loadListAPI, {
            params: {
              token: this.token,
              type: "min",
              sns_type: "instagram",
              influencer: this.profile_data.ig_id,
            },
          })
          .then((response) => {
            this.list = response.data.mylist;
            this.active_list_count = response.data.active_list_count;
          });
    },
    addInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const ig_id = this.profile_data.ig_id;
      const ig_id_js = [ig_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("influencer", JSON.stringify(ig_id_js));
      params.append("sns_type", "instagram");
      params.append("token", this.token);
      this.axios.post(addInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count += 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("addInfluencerReactive", this.influencer_index, name, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.account_name + "を" + name + "に追加しました",
        });
        this.$store.dispatch("loadSidemenuOption", this.token);
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    addSimilarInfluencer(id, name) {
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("influencer", JSON.stringify(this.checkList));
      params.append("sns_type", "instagram");
      params.append("token", this.token);
      this.axios.post(addInfluencerAPI, params).then(() => {
        var similar_account = this.similar_account;
        for (let i = 0; i < this.checkList.length; i++) {
          for (let z = 0; z < similar_account.length; z++) {
            if (this.checkList[i] === similar_account[z].ig_id) {
              this.similar_account[z].list_count += 1;
              if (this.similar_account[z].list_in) {
                this.similar_account[z].list_in.push({ list_name: name });
              } else {
                this.similar_account[z].list_in.push({ list_name: name });
              }

            }
          }
        }
        this.$emit("loadFromDetail", id);
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.checkList.length + "名のインフルエンサーを" + name + "に追加しました",
        });
        this.$store.dispatch("loadSidemenuOption", this.token);
        this.checkList = [];
      });
    },
    deleteInfluencer(id, name, index) {
      this.add_delete_loading = true;
      this.add_delete_index = index;
      const ig_id = this.profile_data.ig_id;
      const ig_id_js = [ig_id];
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("sns_type", "instagram");
      params.append("influencer", JSON.stringify(ig_id_js));
      params.append("token", this.token);
      this.axios.post(deleteInfluencerAPI, params).then(() => {
        this.add_delete_loading = false;
        this.profile_data.list_count -= 1;
        this.$refs.add_list_detail.loadList();
        this.$emit("loadFromDetail", id);
        this.$emit("deleteInfluencerReactive", this.influencer_index, id);
        this.checkList = [];
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.account_name + "を" + name + "から削除しました",
        });
        if (this.tabs == "note") {
          this.$refs.note.loadNote(false);
        }
      });
    },
    favorite() {
      if (this.profile_data.favorite == 0) {
        this.profile_data.favorite = 1;
      } else {
        this.profile_data.favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.profile_data.ig_id);
      params.append("sns_type", "instagram");
      params.append("favorite", this.profile_data.favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
      this.$emit("favoriteReactive", this.influencer_index, this.profile_data.favorite);
    },
    storiesReactive() {
      this.$emit("storiesReactive", this.influencer_index, this.profile_data.stories);
      this.profile_data.stories_list = [];
      this.media_type = "feed";
    },
    imgLoaded() {
      //imgErrorと併せて読み込み画像数をカウントし、全画像読み込み時にローディング解除
      this.img_count += 1;
      if (this.img_count == this.post_data.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_count = 0;
      }
    },
    imgReelLoaded() {
      //imgReelErrorと併せて読み込み画像数をカウントし、全画像読み込み時にローディング解除
      this.img_reel_count += 1;
      if (this.img_reel_count >= this.post_data_reel.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_reel_count = 0;
      }
    },
    imgError(index) {
      this.post_data[index].img_url = this.s3BaseUrl + "/postdata/error.jpg";
      this.post_data[index].img_url_m = this.s3BaseUrl + "/postdata/error.jpg";
      this.img_count += 1;
      if (this.img_count == this.post_data.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_count = 0;
      }
    },
    imgReelError(index) {
      this.post_data_reel[index].img_url = this.s3BaseUrl + "/postdata/error.jpg";
      this.post_data_reel[index].img_url_m = this.s3BaseUrl + "/postdata/error.jpg";
      this.img_reel_count += 1;
      if (this.img_reel_count >= this.post_data_reel.length) {
        this.loading = false;
        this.detail_loading = false;
        this.img_reel_count = 0;
      }
    },
    imgDetailLoaded() {
      this.detail_loading = false;
    },
    scrollBottom() {
      if (this.similar_show) {
        document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
      } else {
        this.similar_show = true;
        setTimeout(() => {
          document.getElementById("i-detail-similar").scrollIntoView({ block: "start", behavior: "smooth" });
        }, 100);
      }
    },
    toSetting() {
      this.$router.push("/setting");
    },
    closeDrawer(type) {
      if (type=='feed'){
        this.drawer = false;
        this.chat_value = "";
      } else if (type=='reel'){
        this.reel_drawer = false;
        this.chat_value = "";
      } else if (type=='stories'){
        this.stories_drawer = false;
        this.chat_value = "";
      }
    },
    closeParentDrawer() {
      this.drawer = false;
      this.axios.cancel(this.requestId);
      this.axios.cancel(this.requestId_similar);
      this.similar_data = null;
      this.similar_show = false;
    },
    closeParentDrawerClear() {
      this.resetSearchMedia();
      this.loading = true;
    },
    toYDetail(channel_id) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_youtuberDetailDrawer" : "youtuberDetail",
        params: {
          channel_id: channel_id,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toTTDetail(account_name) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_tiktokerDetailDrawer" : "tiktokerDetail",
        params: {
          account_name: account_name,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toInfluencerDetail(account_name) {
      this.$router.push({
        name: this.child == true ? this.parent_component + "_influencerDetailDrawer" : "influencerDetail",
        params: {
          account_name: account_name,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toInfluencerDetailNewWindow(account_name) {
      let routeData = this.$router.resolve({
        name: "influencerDetail",
        params: {
          account_name: account_name,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    openMessageDrawer() {
      this.message_drawer = true;
    },
    closeMessageDrawer() {
      this.message_drawer = false;
    },
    openInstagram() {
      let url = "https://instagram.com/" + this.account_name + "/";
      window.open(url, "_blank");
    },
    changeTab(tab) {
      this.loading = true;
      if (this.tabs == "post" && tab != "post" && (this.search_type != "all" || this.sort_period != "all" || this.searchPeriodFrom !== "" || this.searchPeriodTo !== "" )) {
        setTimeout(() => {
          this.resetSearchMedia();
          this.searchMedia("all", "");
          this.tabs = tab;
        }, 0);
      } else {
        this.tabs = tab;
        setTimeout(() => {
          this.loading = false;
          var element = document.getElementById("i-detail-wrap");
          element.scroll({
            top: 0,
            behavior: "instant",
          });
        }, 0);
      }
    },
    reportError() {
      this.$intercom.show();
    },
    deleteFlag(id) {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("sns_type", "instagram");
      params.append("id", id);
      this.axios
        .post(changeDeleteFlagAPI, params)
        .then(() => {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "削除フラグを修正しました。",
          });
          this.load();
        })
        .catch(() => {});
    },
    copyLinkName(account_name) {
      var text = account_name;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "ユーザー名がコピーされました",
        });
      });
    },
    copyGetLink(account_name) {
      var text = "php get_single.php -a" + account_name;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "コードがコピーされました",
        });
      });
    },
    commentReactive(comment, list_id) {
      this.$emit("commentReactive", this.ig_id, comment, list_id);
    },
    statusReactive(status, list_id) {
      this.$emit("statusReactive", this.ig_id, status, list_id);
    },
    noteReactive(note_info, property_name) {
      this.$emit("noteReactive", this.ig_id, note_info, property_name);
    },
    tagReactive(type, tag_index, new_tag) {
      this.$emit("tagReactive", this.ig_id, type, tag_index, new_tag);
    },
    handleWordClicked(word) {
      const now = new Date();
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(now.getMonth() - 3);

      const format = date => date.toISOString().split('T')[0];
      this.searchPeriodFrom = format(threeMonthsAgo);
      this.searchPeriodTo = format(now);
      this.tabs = 'post';
      this.search_keyword = '#' + word;
      this.searchGraphPostPeriod = [format(threeMonthsAgo), format(now)];
      this.searchMedia('hashtag', this.search_keyword);
    },
    setWordsFromHashTags() {
      this.words = [];
      const regex = new RegExp(this.pr_word_without_hash);
      let index = 0;
      for (const key in this.hashtagEgr) {
        if (!regex.test(this.hashtagEgr[key].hashtag)) {
          if (this.hashtagEgr[key].average_engagement_rate > 0) {
            this.words.push({
              key: key,
              text: this.hashtagEgr[key].hashtag,
              value: (this.hashtagEgr[key].times * this.hashtagEgr[key].average_engagement_rate) + (index * 0.001),
              times: this.hashtagEgr[key].times,
              average_engagement_rate: this.hashtagEgr[key].average_engagement_rate
            });
            index += 1;
          }
        }
      }
      // value値で降順にソート
      this.words.sort((a, b) => b.value - a.value);
      // 上位100個だけを取得
      this.words = this.words.slice(0, 100);
    },
    selectPostPeriod(type, searchPeriodFrom, searchPeriodTo) {
      this.tabs = type;
      this.searchGraphPostPeriod = [searchPeriodFrom, searchPeriodTo];
      this.searchPostPeriodChange(searchPeriodFrom, searchPeriodTo);
    },
    searchPostPeriodChange(searchPeriodFrom, searchPeriodTo) {
      this.searchPeriodFrom = searchPeriodFrom;
      this.searchPeriodTo = searchPeriodTo;      
      this.searchMedia("all", "");
    },
    averageLikeFormat(val) {
      if (val === null || val === undefined || val === '' || isNaN(val)) {
        return 0;
      }
      const num = Number(val);
      if (num < 10000) {
        return Math.round(num);
      }
      let man = num / 10000;
      let str = man.toFixed(1);
      if (str.endsWith('.0')) {
        str = str.slice(0, -2);
      }
      return str;
    },
  },
  watch: {
    $route() {
      this.load();
      this.closeParentDrawerClear();
      this.checkList = [];
      this.sort_similar_description = "並び替え";
      // this.child = true;
    },
    currentPage() {
      if (this.currentPage > 1) this.tabs = "post";
    },
  },
  filters: {
    lastActivity(val) {
      const now = new Date().getTime();
      const lastUpdate = val / 1000;
      const diffSec = now - lastUpdate;
      if (diffSec / (1000 * 60 * 60 * 24 * 7 * 4) > 1) {
        const diffMonth = Math.floor(diffSec / (1000 * 60 * 60 * 24 * 7 * 4)) + "ヶ月前";
        return diffMonth;
      } else if (diffSec / (1000 * 60 * 60 * 24 * 7) > 1) {
        const diffWeek = Math.floor(diffSec / (1000 * 60 * 60 * 24 * 7)) + "週間前";
        return diffWeek;
      } else if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
    timestampToDate(val) {
      return new Date(val / 1000).toLocaleDateString();
    },
    timestampToTime(val) {
      return new Date(val / 1000).toLocaleString().slice(0, -3);
    },
    tenThousand(val) {
      return (val / 10000).toFixed(1);
    },
    decimal(val) {
      return Math.floor(val);
    },
    decimalOne(val) {
      if (val == Infinity) {
        return "NA";
      } else {
        return Math.floor(val * 10) / 10;
      }
    },
    growthrate(val) {
      if (val == 0 || val == null) {
        return "NA";
      } else {
        return val;
      }
    },
    frequency(val) {
      if (val) {
        return val;
      } else {
        return "NA";
      }
    },
  },
};
</script>

<style></style>